module.exports = __webpack_public_path__ + "static/media/pinIcon.b1f36abb.svg";